import './Tools.css';
import ICON_MAP from '../../utils/iconMap';

export const ToolCard = ({ tool }) => {
	const IconComponent = ICON_MAP[tool.icon];

	return (
		<div
			id={`tool-${tool.slug}`}
			className="tool-card"
			onClick={() => { window.location.href = `/tools/${tool.slug}`; }}
			role="article"
		>
			<div className="tool-card-image">
				<span className="tool-card-icon">
					{IconComponent ? <IconComponent sx={{ fontSize: 'inherit', color: 'inherit' }} /> : tool.icon}
				</span>
			</div>
			<div className="tool-card-content">
				<h3 className="tool-card-title">{tool.title}</h3>
				<p className="tool-card-description">{tool.description}</p>
				<div className="tool-card-footer">
					<span className="tool-card-action">
						Use Calculator
						<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
							<path d="M5 12h14M12 5l7 7-7 7" />
						</svg>
					</span>
				</div>
			</div>
		</div>
	);
};
